/* eslint-disable no-unused-vars */

/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_STATION_URL, COMMON_HEADER_CONFIG} from "../config";

class StationService {
  getAccessToken = () => localStorage.getItem("accessToken");

  getStationPPList = (platform = "centralweb", parentStationId = "") =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_STATION_URL}/stations/child-of-station`,
        params: {
          platform_key: platform,
          function: "pp",
          parent_id: parentStationId,
          is_active: true
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  searchStations = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_STATION_URL}/stations`,
        params: {
          size: 100,
          page: 1,
          ...data
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListStations = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_STATION_URL}/stations`,
        params: {
          size: 100,
          page: 1
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListStationsByFC = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_STATION_URL}/stations`,
        params: {
          size: 100,
          page: 1,
          ...data
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListStationsByFunction = (data) =>
    new Promise((resolve, reject) => {
      const dataGet = JSON.stringify(data);
      const config = {
        method: "post",
        url: `${API_STATION_URL}/pickup-stations`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data: dataGet
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createStation = (data) =>
    new Promise((resolve, reject) => {
      const dataCreate = JSON.stringify(data);
      const config = {
        method: "post",
        url: `${API_STATION_URL}/station`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data: dataCreate
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getStation = (stationId) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_STATION_URL}/station/${stationId}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getPrdNotSellInStation = (params) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_STATION_URL}/station-sku-exclude`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response?.data || []);
          } else {
            reject(response?.data?.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  addPrdNotSellToStation = (inputData) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_STATION_URL}/station-sku-exclude`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data: inputData
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  removePrdNotSellToStation = (itemId) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "delete",
        url: `${API_STATION_URL}/station-sku-exclude/${itemId}`,
        headers: {
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          console.log(response, "responseDelete");
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListStationFunctions = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_STATION_URL}/station-function`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteStation = (stationId) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "delete",
        url: `${API_STATION_URL}/station/${stationId}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data.code === "success") {
            resolve(response.data.code);
          } else {
            reject(response.data.code);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateStation = (data) =>
    new Promise((resolve, reject) => {
      const dataUpdate = JSON.stringify(data);
      const config = {
        method: "put",
        url: `${API_STATION_URL}/station/${data.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data: dataUpdate
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error.response);
        });
    });

  addStationSetting = (data) =>
    new Promise((resolve, reject) => {
      // const dataStationSetting = JSON.stringify(data);
      const config = {
        method: "post",
        url: `${API_STATION_URL}/station/setting`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            resolve(response.data);
          }
        })
        .catch((error) => {
          reject(error.response);
        });
    });
}

const stationService = new StationService();

export default stationService;
